import Vue from "vue";
import Vuex from "vuex";

import accolades from "./modules/accolades";
import pictures from "./modules/pictures";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    accolades,
    pictures,
  },
  state: {
    applicationName: "Final Finish Taxidermy",
    navigationDrawer: false,
    links: [
      { text: "Home", href: "#" },
      { text: "Accolades", href: "#accolades" },
      { text: "Prices", href: "#prices" },
      { text: "About", href: "#about" },
      { text: "Contact", href: "#contact" },
      { text: "Testimonials", href: "#testimonials" },
    ],
    methodsOfContact: [
      {
        name: "Email",
        icon: "mdi-email-outline",
        value: "finalfinishtaxidermy@gmail.com",
        url: "mailto:finalfinishtaxidermy@gmail.com",
        showOnContact: true,
        showOnFooter: true,
      },
      {
        name: "Address",
        icon: "mdi-map-marker",
        url:
          "https://maps.google.com/?q=8430%20N%20700%20W%20Ligonier%2C%20IN%2C%2046767",
        value: "8430 N 700 W, Ligonier, IN, 46767",
        showOnContact: true,
        showOnFooter: false,
      },
      {
        name: "Phone",
        icon: "mdi-phone",
        url: "tel:+1-260-215-3542",
        value: "(260) 215-3542",
        showOnContact: true,
        showOnFooter: false,
      },
      {
        name: "Facebook",
        icon: "mdi-facebook",
        url: "https://www.facebook.com/Final-Finish-Taxidermy-107584337725260",
        showOnContact: false,
        showOnFooter: true,
      },
      {
        name: "Instagram",
        icon: "mdi-instagram",
        url: "https://instagram.com/final.finish.taxidermy",
        showOnContact: false,
        showOnFooter: true,
      },
    ],
    sectionColor: "grey lighten-4",
  },
  getters: {
    methodsOfContactForContactSection: (state) => {
      return state.methodsOfContact.filter(
        (methodOfContact) => methodOfContact.showOnContact
      );
    },
    methodsOfContactForFooter: (state) => {
      return state.methodsOfContact.filter(
        (methodOfContact) => methodOfContact.showOnFooter
      );
    },
    emailContact: (state) => {
      return state.methodsOfContact.filter(
        (methodOfContact) => methodOfContact.name === "Email"
      )[0];
    },
    facebookUrl: (state) => {
      return state.methodsOfContact.filter(
        (methodOfContact) => methodOfContact.name === "Facebook"
      )[0].url;
    },
    instagramUrl: (state) => {
      return state.methodsOfContact.filter(
        (methodOfContact) => methodOfContact.name === "Instagram"
      )[0].url;
    },
    phoneContact: (state) => {
      return state.methodsOfContact.filter(
        (methodOfContact) => methodOfContact.name === "Phone"
      )[0];
    },
  },
  mutations: {
    setDrawer: (state, payload) => (state.navigationDrawer = payload),
    toggleDrawer: (state) => (state.navigationDrawer = !state.navigationDrawer),
  },
  actions: {},
});
